// extracted by mini-css-extract-plugin
export var buttonsContainer = "_JoinInstitutionsV2-module--buttonsContainer--8mXL0";
export var ellipseBottomBackgroundShape = "_JoinInstitutionsV2-module--ellipseBottomBackgroundShape--zw6iB";
export var ellipseTop2BackgroundShape = "_JoinInstitutionsV2-module--ellipseTop2BackgroundShape--VfV9L";
export var ellipseTopBackgroundShape = "_JoinInstitutionsV2-module--ellipseTopBackgroundShape--ZOWQx";
export var header = "_JoinInstitutionsV2-module--header--oeTd0";
export var header2 = "_JoinInstitutionsV2-module--header2--HvXGx";
export var headerV4 = "_JoinInstitutionsV2-module--headerV4--go3HJ";
export var innerContainer = "_JoinInstitutionsV2-module--innerContainer--GnsEg";
export var joinInstitutionsContainer = "_JoinInstitutionsV2-module--joinInstitutionsContainer--AIeh2";
export var limitWidthOnLargeScreens = "_JoinInstitutionsV2-module--limitWidthOnLargeScreens--hTEsU";
export var outerContainer = "_JoinInstitutionsV2-module--outerContainer--oSqpK";
export var rowContainer = "_JoinInstitutionsV2-module--rowContainer--8t1MV";
export var subheader = "_JoinInstitutionsV2-module--subheader--SzmJR";
export var subheaderV4 = "_JoinInstitutionsV2-module--subheaderV4--n9nb1";